/**
 * "Estimated schedule" badge for maintenance content.
 *
 * Maintenance intervals are derived by our rules engine from powertrain,
 * transmission and drivetrain data — they are not manufacturer-published
 * schedules like the EPA/NHTSA figures behind the green "Verified" badge.
 * The amber treatment keeps the two visually distinct on purpose.
 */
export function EstimatedBadge({ className }: { className?: string }) {
  return (
    <span
      className={`estimated-badge whitespace-nowrap ${className ?? ""}`}
      title="Intervals estimated from powertrain data and mainstream manufacturer service practice — not a manufacturer-published schedule."
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      Estimated schedule
    </span>
  );
}
